const TranslateSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 10C16.4089 10 16.7766 10.249 16.9285 10.6286L20.9285 20.6286C21.1336 21.1414 20.8842 21.7234 20.3714 21.9285C19.8586 22.1336 19.2766 21.8842 19.0715 21.3714L17.823 18.25H14.177L12.9285 21.3714C12.7234 21.8842 12.1414 22.1336 11.6286 21.9285C11.1158 21.7234 10.8664 21.1414 11.0715 20.6286L15.0715 10.6286C15.2234 10.249 15.5911 10 16 10ZM14.977 16.25H17.023L16 13.6926L14.977 16.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.47 3.15189C7.93834 2.85918 8.55529 3.00156 8.848 3.46989L9.80425 4.99989H13C13.5523 4.99989 14 5.44761 14 5.99989C14 6.55218 13.5523 6.99989 13 6.99989H11.258C10.8404 8.35476 10.1154 10.0789 9.06923 11.5734C9.05193 11.5981 9.03451 11.6228 9.01698 11.6474C9.80849 12.3867 10.8118 12.8974 12.083 13.0034C12.6334 13.0492 13.0424 13.5326 12.9965 14.083C12.9507 14.6333 12.4673 15.0423 11.917 14.9965C10.1526 14.8494 8.77336 14.1341 7.71489 13.1659C6.60276 14.2234 5.20145 14.9999 3.5 14.9999C2.94772 14.9999 2.5 14.5522 2.5 13.9999C2.5 13.4476 2.94772 12.9999 3.5 12.9999C4.57185 12.9999 5.5471 12.4942 6.41366 11.6442C6.32424 11.5117 6.23875 11.3777 6.1571 11.2429C5.29183 9.8139 4.82218 8.23664 4.61567 6.99989H3C2.44772 6.99989 2 6.55218 2 5.99989C2 5.44761 2.44772 4.99989 3 4.99989H7.44575L7.152 4.52989C6.85929 4.06155 7.00166 3.4446 7.47 3.15189ZM9.15168 6.99989H6.649C6.83016 7.89795 7.17214 8.97739 7.73166 9.97335C8.34577 8.99962 8.82089 7.93537 9.15168 6.99989Z"
      fill="currentColor"
    />
    <path
      d="M5.09717 16C5.09717 16 5.26806 17.619 5.93368 18.2947C6.59931 18.9704 8.19434 19.1438 8.19434 19.1438C8.19434 19.1438 6.59931 19.3173 5.93368 19.9929C5.26806 20.6686 5.09717 22.2876 5.09717 22.2876C5.09717 22.2876 4.92628 20.6686 4.26065 19.9929C3.59502 19.3173 2 19.1438 2 19.1438C2 19.1438 3.59502 18.9704 4.26065 18.2947C4.92628 17.619 5.09717 16 5.09717 16Z"
      fill="currentColor"
    />
    <path
      d="M19.0972 2C19.0972 2 19.2681 3.61904 19.9337 4.2947C20.5993 4.97035 22.1943 5.14381 22.1943 5.14381C22.1943 5.14381 20.5993 5.31727 19.9337 5.99293C19.2681 6.66858 19.0972 8.28762 19.0972 8.28762C19.0972 8.28762 18.9263 6.66858 18.2607 5.99293C17.595 5.31727 16 5.14381 16 5.14381C16 5.14381 17.595 4.97035 18.2607 4.2947C18.9263 3.61904 19.0972 2 19.0972 2Z"
      fill="currentColor"
    />
  </svg>
);
export default TranslateSvg;
